<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-01 20:05:47
 * @最后编辑: Betway
 * @最后修改时间: 2022-01-06 13:24:17
-->
<template>
  <v-card>
    <v-card-text>
      <mrc_ess_iconGroup
        :is_disabled="readonly"
        :showReturn="false"
        @handleEdit="handleEdit"
        @handleDel="handleDel"
      ></mrc_ess_iconGroup>

      <v-row>
        <v-col cols="12" class="d-flex">
          <mrc_ess_switch
            v-if="$store.state.uuid"
            :true-value="1"
            :false-value="0"
            :readonly="readonly"
            v-model="list.status"
            :true-text="$t('label_To_enable_the')"
            :false-text="$t('label_disable')"
          ></mrc_ess_switch>
        </v-col>
        <v-col cols="12" sm="6">
          <mrc_ess_multiText
            v-model.trim="list.language_master_key"
            :readonly="readonly"
            :isNational="judegNational('language_master_key')"
            :error-messages="
              $errors(
                'list',
                'language_master_key',
                requiredRule.concat(nocharacter)
              )
            "
            label="Key*"
          ></mrc_ess_multiText>
        </v-col>
        <v-col cols="12" sm="6">
          <mrc_ess_multiText
            v-model="list.client_type"
            :readonly="true"
            :isNational="judegNational('label_Client_type')"
            :label="$t('label_Client_type')"
          ></mrc_ess_multiText>
        </v-col>
        <v-col cols="12" sm="6">
          <mrc_ess_input
            v-model="list.version"
            :readonly="true"
            :label="$t('label_version')"
          ></mrc_ess_input>
        </v-col>
        <!-- 数据类型 -->
        <v-col cols="12" sm="6">
          <mrc_ess_dictName
            v-model="list.language_data_type"
            :disabled="readonly"
            :label="$t('label_type_of_data') + '*'"
            :rules="false"
            :chips="false"
            :errMsg="$errors('list', 'language_data_type', requiredRule)"
            dict_name="internation_data_type"
          ></mrc_ess_dictName>
        </v-col>

        <v-col cols="12" sm="6">
          <mrc_ess_autoComplete
            :label="$t('label_The_module')"
            :readonly="readonly"
            moduleView
            v-model="list.language_master_module_uuid"
            :prompt_name="module_reference"
          >
          </mrc_ess_autoComplete>
        </v-col>
        <v-col cols="12" sm="6">
          <mrc_ess_prompt
            v-model="list.language_master_function_uuid"
            :obj="function_reference"
            :label="$t('label_function')"
            chips
            :rules="false"
            :disabled="readonly"
          >
          </mrc_ess_prompt>
        </v-col>
        <v-col cols="12">
          <!-- 去掉了.trim 2021-01-06 hb -->
          <mrc_ess_multiText
            v-model="list.language_master_content"
            :isNational="judegNational('language_master_content')"
            :readonly="readonly"
            :error-messages="
              $errors(
                'list',
                'language_master_content',
                requiredRule.concat(nocharacter)
              )
            "
            :label="$t('label_content') + '*'"
          ></mrc_ess_multiText>
        </v-col>
        <v-col cols="12" v-if="$store.state.uuid">
          <mrc_ess_multiText
            v-model="list.language_master_final_key"
            :isNational="judegNational('language_master_final_key')"
            :readonly="true"
            :label="$t('label_Final_code') + '*'"
          ></mrc_ess_multiText>
        </v-col>
        <v-col cols="12" v-if="list.language_data_type == 'error'">
          <mrc_ess_multiText
            v-model.trim="list.language_master_error_reason_method"
            :isNational="judegNational('language_master_error_reason_method')"
            :readonly="readonly"
            :label="$t('label_causes_and_solutions') + '*'"
            :error-messages="
              $errors(
                'list',
                'language_master_error_reason_method',
                maxLength('2000')
              )
            "
          ></mrc_ess_multiText>
        </v-col>
      </v-row>
    </v-card-text>
    <mrc_ess_submitBtn
      @cancel="cancel"
      @success="success"
      :loading="btnIsLoading"
      v-if="!readonly"
    ></mrc_ess_submitBtn>
  </v-card>
</template>

<script>
import {
  gethintList,
  gethintDetail,
  deletehint,
  addehint,
} from "@/service/api/internationalization.js";
import {
  required,
  maxLength,
  between,
  email,
  url,
} from "vuelidate/lib/validators";
export default {
  components: {},
  props: {},
  data() {
    return {
      btnIsLoading: false,
      readonly: true, //默认只读
      list: {
        status: 1,
      },
    };
  },
  created() {},
  async mounted() {
    await this.national("mrbase_sys_language_master");
    if (this.$store.state.uuid) {
      await this.getdetail();
      this.readonly = this.$store.state.iconstatus;
    } else {
      this.list.status = 1;
      this.readonly = false;
      this.list.version = this.$store.state.version;
      this.list.client_type = this.$store.state.client_type;
    }
  },
  methods: {
    handleEdit() {
      this.readonly = !this.readonly;
      this.$store.commit("set_iconstatus", this.readonly);
    },
    handleDel() {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      })
        .then((res) => {
          deletehint({
            uuid: this.$store.state.uuid,
          }).then((res) => {
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            });
            this.$router.push({
              name: "allClientMsg",
            });
          });
        })
        .catch((err) => {});
    },
    cancel() {
      // const that = this
      this.$myConfirm({
        content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
      })
        .then((res) => {
          this.$router.push({
            name: "allClientMsg",
          });
        })
        .catch((err) => {});
    },
    success() {
      this.$v.list.$touch();
      if (this.$v.list.$error) return;
      this.btnIsLoading = true;
      if (this.$store.state.uuid) {
        let list = this.$deletefield(null, this.list);
        delete list.language_master_final_key;
        delete list.language_master_id;
        // delete list.language_master_error_reason_method
        addehint({ ...list }).then((res) => {
          if (res.code == 200) {
            this.$Message({
              text: this.$t("message_The_operation_was_successful"),
            });
            this.$router.push({
              name: "allClientMsg",
            });
          } else {
            this.btnIsLoading = false;
          }
        });
      } else {
        delete this.list.language_master_final_key;
        if (this.list.language_data_type != "error") {
          delete this.list.language_master_error_reason_method;
        }
        this.list.version ? "" : delete this.list.version;
        // console.log(this.list);
        // this.btnIsLoading = false
        // return
        addehint({ ...this.list }).then((res) => {
          if (res.code == 200) {
            this.$Message({
              text: this.$t("message_The_operation_was_successful"),
            });
            this.$router.push({
              name: "allClientMsg",
            });
          } else {
            this.btnIsLoading = false;
          }
        });
      }
    },
    async getdetail() {
      const uuid = this.$store.state.uuid;
      const res = await gethintDetail({ uuid });
      if (res.code === "200") {
        this.list = res.data;
      }
    },
  },
  computed: {
    // view_language_master_final_key () {
    //   return 'error' + '_' + this.list.language_master_module_uuid + '_' + this.list.language_master_function_uuid + '_nodata'
    // }
    function_reference() {
      return {
        prompt_name: "function_reference",
        uuid: this.list.language_master_module_uuid,
      };
    },
    module_reference() {
      return {
        prompt_name: "module_reference",
        uuid: this.$store.state.currentCompany,
      };
    },
  },
  watch: {},
  validations: {
    list: {
      language_master_key: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      language_master_content: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      language_master_error_reason_method: {
        maxLength: maxLength(2000),
      },
      client_type: {},
      version: {},
      language_data_type: {
        required,
      },
    },
  },
};
</script>

<style scoped>
/* .hintbox /deep/ .iconGroup {
  position: relative;
}
.hintbox /deep/ .btnGroup {
  position: absolute;
  position: absolute;
  top: -55px;
  right: 10px;
} */
</style>
